import React, { useState, useEffect } from "react";
import AccountSettingsPage from "../../entities/AccountSettings";
import AuthService from "../../api/AuthService";
import { useAlert } from "../../context/AlertContext";
import LoaderHelper from "../../utils/Loader/LoaderHelper";
import { useLocation, useNavigate } from "react-router-dom";

const AccountSetting = () => {
  const { showAlert } = useAlert();
  const [imgUrl, setimgUrl] = useState("");
  const [favUrl, setfavUrl] = useState("");
  const [logoUploading, setLogoUploading] = useState(false);
  const [faviconUploading, setFaviconUploading] = useState(false);
  const [data, setData] = useState("");
  const [tax, setTax] = useState("");
  const [payslipData, setPayslipData] = useState([]);
  const [companyToken, setCompanyToken] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();
  const { state } = location || {};
  const from = state?.from;
  const [permission, setPermission] = useState(null);
  const role = localStorage.getItem("role");
  const employeeId = localStorage.getItem("employeeId");

  // Fetch permissions from API only for Employee role
  const fetchPermissions = async () => {
    if ((role === "Employee" || role === "employee") && employeeId) {
      try {
        const permissionResult = await AuthService.getEmployeePermission(employeeId);
        if (permissionResult?.success && permissionResult?.data) {
          const permissions = permissionResult?.data;
          setPermission(permissions);
        }
      } catch (error) {
        console.error("Error fetching permissions:", error);
      }
    } else {
      // For Admin/SuperAdmin, use localStorage
      const permissionObj = localStorage.getItem("permission");
      setPermission(permissionObj ? JSON.parse(permissionObj) : null);
    }
  };

  useEffect(() => {
    fetchPermissions();
    
    // Listen for permission updates
    const handlePermissionUpdate = () => {
      fetchPermissions();
    };
    
    window.addEventListener("permissionUpdated", handlePermissionUpdate);
    return () => {
      window.removeEventListener("permissionUpdated", handlePermissionUpdate);
    };
  }, []);

  useEffect(() => {
    if (permission !== null || (role !== "Employee" && role !== "employee")) {
      // getCompanyList()
      getPayslipFormat();
    }
  }, [permission])


  const [loading, setLoading] = useState(false);
  const handleUrl = async (data, type) => {
    if (type === "logo") setLogoUploading(true);
    else if (type === "favicon") setFaviconUploading(true);
    try {
      const result = await AuthService.handleSingleImgUrl(data);
      if (result?.success && result?.data) {
        if (type === "logo") {
          setimgUrl(result?.data);
        } else if (type === "favicon") {
          setfavUrl(result?.data);
        }
      } else {
        showAlert(result?.message || "Failed to upload image", "error");
      }
    } catch (error) {
      showAlert(error?.message || "Failed to upload image", "error");
    } finally {
      if (type === "logo") setLogoUploading(false);
      else if (type === "favicon") setFaviconUploading(false);
    }
  };
  const handleCompanyDetails = async (id) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.handleCompanyDetails(id);
      if (result?.success) {

        LoaderHelper.loaderStatus(false);
        setData(result?.data?.company)
        setCompanyToken(result?.data?.token)
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
      // console.error("Error occurred:", error);
    }
  };

  // const getAccountSettings = async () => {
  //   LoaderHelper.loaderStatus(true);
  //   try {
  //     const result = await AuthService.getAccountSetting();
  //     if (result?.success) {
  //       setData(result?.data);

  //       LoaderHelper.loaderStatus(false);

  //     } else {
  //       LoaderHelper.loaderStatus(false);
  //     }
  //   } catch (error) {
  //     LoaderHelper.loaderStatus(false);
  //     // console.error("Error occurred:", error);
  //   }
  // };
  const getPayslipFormat = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getPayslipFormat();
      if (result?.success) {
        setPayslipData(result?.data);

        LoaderHelper.loaderStatus(false);

      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
      // console.error("Error occurred:", error);
    }
  };
  const getTaxType = async (country) => {
    try {
      const result = await AuthService.getTaxType(country);
      if (result) {

        setTax(result);
      } else {
        setLoading(false);

      }
    } catch (error) {
      setLoading(false);
    }
  };
  const handleAccountSetting = async (user, data, phone, phoneCode, deskNoti, emailNoti, orders, vatAndGst, selectedCurrency, format) => {
    LoaderHelper.loaderStatus(true);

    setLoading(true)
    try {
      const result = await AuthService.accountSettingsWithNewToken(user, data, phone, phoneCode, imgUrl, favUrl, deskNoti, emailNoti, orders, vatAndGst, selectedCurrency, format, companyToken);
      if (result?.success === true) {
        setLoading(false)
        showAlert(result?.message, "success");
        LoaderHelper.loaderStatus(false);
        navigate("/dashboard/additionalInformation", { state: { isEditable: true, companyToken } })

      } else {

        setLoading(false)
        showAlert(result?.message, "error");
      }
    } catch (error) {
      setLoading(false)
      showAlert(error, "error");
    }
  };

  const handleNewCompany = async (user, data, phone, phoneCode, deskNoti, emailNoti, orders, vatAndGst, selectedCurrency, format) => {
    LoaderHelper.loaderStatus(true);

    setLoading(true)
    try {
      const result = await AuthService.NewCompany(user, data, phone, phoneCode, imgUrl, favUrl, deskNoti, emailNoti, orders, vatAndGst, selectedCurrency, format);
      if (result?.success === true) {
        setLoading(false)
        showAlert(result?.message, "success");
        // window.location.reload()
        LoaderHelper.loaderStatus(false);
        navigate("/dashboard/additionalInformation", { state: { isEditable: true, companyToken } })
      } else {

        setLoading(false)
        showAlert(result?.message, "error");
      }
    } catch (error) {
      setLoading(false)
      showAlert(error, "error");
    }
  };


  // Don't render until permissions are loaded for Employee role
  if (permission === null && (role === "Employee" || role === "employee")) {
    return null;
  }

  // Check if user has permission to view/edit account settings
  const hasViewPermission = permission?.account?.isView === true || role === "Admin" || role === "SuperAdmin";
  const hasEditPermission = permission?.account?.isEdit === true || role === "Admin" || role === "SuperAdmin";

  if (!hasViewPermission && !hasEditPermission) {
    return null; // Or show access denied message
  }

  return (
    <AccountSettingsPage data={data} handleCompanyDetails={handleCompanyDetails} from={from} handleAccountSetting={handleAccountSetting} loading={loading} handleUrl={handleUrl} imgUrl={imgUrl} favUrl={favUrl} handleNewCompany={handleNewCompany}
      getTaxType={getTaxType} tax={tax} payslipData={payslipData} companyToken={companyToken} permission={permission} role={role}
      logoUploading={logoUploading} faviconUploading={faviconUploading} />
  )

}

export default AccountSetting;
